import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { deleteFavorite, getFavoritesList, getMeFavorites, setFavorite } from '../functions/favorites';
import { FavoriteListParams } from '../models/favoritesModels';

export const useSetFavorite = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['set-favorite'],
    mutationFn: setFavorite,
    onError: (e: any) => {
      showError({});
      console.error('Error adding to favorite', e);
    }
  });
};

export const useDeleteFavorite = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['delete-favorite'],
    mutationFn: deleteFavorite,
    onError: (e: any) => {
      showError({});
      console.error('Error deleting from favorites', e);
    }
  });
};

export const useGetFavorites = (params: FavoriteListParams) =>
  useInfiniteQuery({
    queryKey: ['get-favorite', params.n, params.limit, params.type],
    queryFn: getFavoritesList,
    initialPageParam: '0',
    getNextPageParam: (lastPage) => {
      if (lastPage.last) return lastPage.last;
      else return null;
    }
  });

export const useGetMeFavorites = () =>
  useQuery({
    queryKey: ['get-me-favorites'],
    queryFn: () => getMeFavorites()
  });

export const useGetMeFavoritesAsync = () =>
  useMutation({
    mutationKey: ['get-me-favorites-async'],
    mutationFn: getMeFavorites,
    onError: (e: any) => {
      console.error('Error get me async favorites', e);
    }
  });
